import { notFound } from "@tanstack/react-router";
import { seoMeta } from "@/lib/ui/seo";
import { kennelListingsSearchSchema } from "./kennel-listings-search.contract.ts";
import { useProviderHomeEnabled } from "./provider-home-flag.ts";

function portalHead(title: string, url: string) {
    return () =>
        seoMeta({
            title,
            description: "Manage your kennel on Wags.",
            url,
            noindex: true,
            nofollow: true,
        });
}

export const kennelGateRoute = {
    ssr: false as const,
    beforeLoad: () => {
        if (!useProviderHomeEnabled.read()) throw notFound();
    },
};

export const kennelSignInRoute = {
    ssr: false as const,
    head: portalHead("Provider sign in · Wags", "/kennel/sign-in"),
};

export const kennelClaimRoute = {
    ssr: false as const,
    head: portalHead("Claim your page · Wags", "/kennel/claim"),
};

export const kennelDashboardRoute = {
    ssr: false as const,
};

export const kennelHomeRoute = {
    ssr: false as const,
    head: portalHead("Home · Wags kennel", "/kennel"),
};

export const kennelListingsRoute = {
    ssr: false as const,
    validateSearch: kennelListingsSearchSchema,
    head: portalHead("Listings · Wags kennel", "/kennel/listings"),
};

export const kennelListingDetailRoute = {
    ssr: false as const,
    head: portalHead("Listing · Wags kennel", "/kennel/listings"),
};

export const kennelMessagesRoute = {
    ssr: false as const,
    head: portalHead("Messages · Wags kennel", "/kennel/messages"),
};

export const kennelThreadRoute = {
    ssr: false as const,
    head: portalHead("Message · Wags kennel", "/kennel/messages"),
};

export const kennelTasksRoute = {
    ssr: false as const,
    head: portalHead("Scheduled · Wags kennel", "/kennel/tasks"),
};

export const kennelNotesRoute = {
    ssr: false as const,
    head: portalHead("Notes · Wags kennel", "/kennel/notes"),
};

export const kennelAdvertisingRoute = {
    ssr: false as const,
    head: portalHead("Advertising · Wags kennel", "/kennel/advertising"),
};

export const kennelMoreRoute = {
    ssr: false as const,
    head: portalHead("More · Wags kennel", "/kennel/more"),
};
